import { render, staticRenderFns } from "./BulkAddToGroupModal.vue?vue&type=template&id=4d7427c4&"
import script from "./BulkAddToGroupModal.vue?vue&type=script&lang=js&"
export * from "./BulkAddToGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports